import React, {useEffect, useState, useRef} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    Box,
    ButtonBase,
    Fade,
    Slide,
    Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { ArrowUpRight } from 'lucide-react';
import useAuth from 'src/hooks/useAuth';

const CAMPAIGN = {
    id: "06042025",
    title: "Upgrade your MMS",
    body: 'Get started with OptiFleet\u2122 for free*.',
    image: '',
    link: "https://services.foundrydigital.com/optifleet-2"
}

const useStyles = makeStyles()(() => ({
    marketingButtonTextHeading: {
        color: "#CDD5DF",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: "20px",
        textAlign: "left",
        margin: "4px 0"
    },
    marketingButtonTextContent: {
        color: "#9999A1",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "20px",
        textAlign: "left",
        margin: "4px 0"
    },
    // marketingImageContainer: {
    //     transitionDuration: "0.3s",
    //     marginBottom: 16,
    //     '&:hover': {
    //         height: 230,
    //         "& .marketingImage": {
    //             display: "flex",
    //             height: 90,
    //             width: 155,
    //             backgroundSize: 'contain',
    //             backgroundPosition: 'left',
    //             backgroundRepeat: 'no-repeat',
    //             backgroundOrigin: 'content-box',
    //             backgroundColor: "var(--uishell-color-surface)",
    //             backgroundImage: `url(${CAMPAIGN.image})`,
    //             borderRadius: "6px"
    //         }
    //     }
    // },
    marketingNoImageContainer: {
        height: "100%",
        marginBottom: 16,
    }
    }));
  
const MarketingBox = () => {
    const { loggedInUser } = useAuth();
    const containerRef = useRef(null)
    const [isHovering, setIsHovering] = useState(false);
    const [loading, setLoading] = React.useState(true);
    const [show, setShow] = React.useState(false);
    const [ campaign, setCampaign ] = useState('')
    const { classes } = useStyles();

    const MarketingBox = styled('div')({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "18px",
        position: 'relative',
        height: 140,
        margin: "0 18px",
        borderRadius: "8px",
        border: "1px solid #333339",
        backgroundColor: "#121926",
        boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)",
        overflow: 'hidden',
    });

    const SnoozeBox = styled(ButtonBase)(({ }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }));

    const handleSnooze = () => {
        let snoozedCampaignobject = localStorage.getItem("snoozedCampaignobject")
        if(!snoozedCampaignobject || (snoozedCampaignobject && JSON.parse(snoozedCampaignobject).campaignId !== campaign.id)){
            let date = new Date();
            setShow(false)
            snoozedCampaignobject = {
                campaignId: campaign.id,
                snooze: date.setDate(date.getDate() + 7)
            }
            localStorage.setItem("snoozedCampaignobject", JSON.stringify(snoozedCampaignobject))
        }
        else {
            snoozedCampaignobject = JSON.parse(snoozedCampaignobject)
            let date = new Date();
            setShow(false)
            snoozedCampaignobject = {
                campaignId: campaign.id,
                snooze: date.setDate(date.getDate() + 30)
            }
            localStorage.setItem("snoozedCampaignobject", JSON.stringify(snoozedCampaignobject))
        }

    }

    useEffect(()=>{
        setCampaign(CAMPAIGN)
    },[])

    useEffect(()=>{
        let snoozedCampaignobject = JSON.parse(localStorage.getItem("snoozedCampaignobject"))
        if( (   !snoozedCampaignobject 
                ||
                    snoozedCampaignobject && 
                    (   snoozedCampaignobject.campaignId !== campaign.id
                        || (snoozedCampaignobject.snooze && Date.now() > snoozedCampaignobject.snooze)
                    )
            )
        ){
            setShow(true)
            setLoading(false)
        }
        else {
            setShow(false)
            setLoading(false)
        }
    },[campaign])

    return (
        !loading ? <div ref={containerRef}>
            {containerRef.current && <Slide 
                in={show} 
                container={containerRef.current}
                timeout={500} 
                easing={{
                    enter: "ease-out",
                    exit: "ease-out"
                }}>
                <div>                  
                    <Fade in={show} timeout={300}
                        easing={{
                            enter: "ease-out",
                            exit: "ease-out"
                    }}>
                        <MarketingBox 
                            onMouseEnter={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                            campaign-id={campaign.id}
                            className={classes.marketingNoImageContainer}
                            >
                            <RouterLink
                                style={{
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                                to={campaign.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Box style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center"
                                    }}>
                                    <Typography style={{marginRight: "4px"}} className={classes.marketingButtonTextHeading}>{campaign.title}</Typography>
                                    <ArrowUpRight size={24} color={"#CDD5DF"}/>
                                </Box>
                                <Typography className={classes.marketingButtonTextContent}>{campaign.body}</Typography>
                                {   
                                    <Fade 
                                        in={isHovering} 
                                        timeout={300} 
                                        easing={{
                                            enter: "ease-out",
                                            exit: "ease-out"
                                        }}>
                                        <div>
                                            <Slide 
                                                direction="up" 
                                                in={isHovering} 
                                                timeout={300} 
                                                container={containerRef.current} 
                                                easing={{
                                                    enter: "ease-out",
                                                    exit: "ease-out"
                                            }}>
                                                <div className={"marketingImage"} ></div>
                                            </Slide>
                                        </div>
                                    </Fade> 
                                }
                            </RouterLink>

                            <SnoozeBox onClick={handleSnooze}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <g clipPath="url(#clip0_70_433)">
                                <path d="M13.75 14.166H17.9166L13.75 18.3327H17.9166M18.2921 10.8327C18.3194 10.5586 18.3333 10.2806 18.3333 9.99935C18.3333 5.39698 14.6023 1.66602 9.99996 1.66602C5.39759 1.66602 1.66663 5.39698 1.66663 9.99935C1.66663 14.6017 5.39759 18.3327 9.99996 18.3327C10.1397 18.3327 10.2786 18.3292 10.4166 18.3224C10.5564 18.3156 10.6954 18.3052 10.8333 18.2915M9.99996 4.99935V9.99935L13.1153 11.557" stroke="#9AA4B2" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_70_433">
                                    <rect width="20" height="20" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                            <Typography style={{marginLeft: "8px", marginTop: "8px", fontWeight: "600"}} className={classes.marketingButtonTextContent}>Snooze</Typography>

                            </SnoozeBox>
                        
                        </MarketingBox>
                    </Fade>
                </div>
            </Slide>}

        </div>  : null
    );
}

export default MarketingBox;